import { useLoaderData } from "react-router-dom";
import Page from '../components/page/Page';
import PageContent from '../components/page/PageContent';
import Pricing from '../components/pricing/Pricing';

export async function loader() {
  const response = await fetch('/api/billing-service-settings');
  const { serviceSettings, bulkPricingRules } = await response.json();
  return { serviceSettings, bulkPricingRules };
}

export default function PricingPage() {
  const { serviceSettings, bulkPricingRules } = useLoaderData() as any;

  return (
    <Page>
      <PageContent color='tertiary'>
        <Pricing serviceSettings={serviceSettings} bulkPricingRules={bulkPricingRules} />
      </PageContent>
    </Page>
  );
}